/** Named constant for the globals database (version control, etc.) */
export const FIRESTORE_DATABASE_GLOBALS = 'cookiearmor-globals'

/**
 * Allowed Firestore database IDs. Only these IDs can be used with getFirestoreDb().
 * Add new IDs here when a new Firestore database is introduced.
 */
export const ALLOWED_FIRESTORE_DATABASE_IDS = [FIRESTORE_DATABASE_GLOBALS]
